import React from 'react';
import { get } from 'lodash';
import { ManualAlert } from '@conviva/portal-graphql-schema';
import { useSearch, useTableSort } from '@components/common/Table/hooks';
import getColumns from './columns';
import formatTableData, { TableData } from './utils/formatTableData';
import { Wrapper } from './styled';
import Table from '@components/common/Table';

interface IProps {
  alerts: ManualAlert[];
}

const rowClassName = ({ rowData }: { rowData: TableData }) => {
  const state = get(rowData, 'source.state', true);
  return !state ? 'alert-disabled' : '';
};

const defaultSort = { key: 'time', order: 'desc' };

const AlertTable = ({ alerts }: IProps) => {
  const data = alerts.map(formatTableData);

  // TODO: cleanup with a multisearch hook
  const { filteredRows: nameFilteredRows, ...nameSearchProps } = useSearch({
    data,
    columnKey: 'name',
  });
  const { filteredRows, ...filterSearchProps } = useSearch({
    data: nameFilteredRows,
    columnKey: 'filter.name',
  });

  // sort
  const { sortBy, onColumnSort, sortedData } = useTableSort({ data: filteredRows, defaultSort });

  const columns = getColumns({ nameSearchProps, filterSearchProps });

  return (
    <Wrapper>
      <Table
        fixed={true}
        data={sortedData}
        columns={columns}
        rowKey="id"
        sortBy={sortBy}
        onColumnSort={onColumnSort}
        rowClassName={rowClassName}
        expandColumnKey="name"
      />
    </Wrapper>
  );
};

export default AlertTable;
